import ApiHandler from '@/api/base'

class OnboardingAiApiHandler extends ApiHandler {
  /**
   * @returns {Promise<{
   *   id: any,
   *   stateId: any,
   *   data: Array<{ dataTypeId: any, value: any, statusId: any }>
   * }>}
   */
  async getOnboarding() {
    const { data } = await this.http.get('/onboarding')

    return data
  }

  async updateOnboardingState({ id, stateId }) {
    return await this.http.put(`/onboarding/${id}`, {
      stateId
    })
  }

  async saveOnboardingData({ onboardingId, dataTypeId, value }) {
    const { data } = await this.http.post('/onboarding/data', {
      onboardingId,
      dataTypeId,
      value
    })

    return data
  }
}

export default OnboardingAiApiHandler
